import React, { useState, useEffect, useCallback } from 'react';
import { Pie, Bar } from 'react-chartjs-2';
import axios from 'axios';
import jsPDF from "jspdf";
import ExcelJS from 'exceljs';
import "jspdf-autotable";
import 'react-datepicker/dist/react-datepicker.css';
import { Link,useNavigate } from 'react-router-dom';
import pds from './pds.PNG';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import {
  Chart as ChartJS, // Use ChartJS instead of Chart
  ArcElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale,
  BarElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';  // Import the datalabels plugin
import './QcCmrDashboard.css';

// Register the required chart elements
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale,
  BarElement,
  ChartDataLabels  // Register the datalabels plugin to display text inside the chart
);

// Home component
const QcCmrDashboard = () => {
     const navigate = useNavigate();
      const [activeButton, setActiveButton] = useState('QC-CMR');
  const [userInfo, setUserInfo] = useState({
    fullName: '',
    employeeId: ''
  });
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData) {
      // Extract the first name from fullName (only the first word)
      const firstName = userData.fullName.split(' ')[0];

      // Set the state with firstName and employeeId
      setUserInfo({
        fullName: firstName,  // Only first name is considered
        employeeId: userData.employeeId,
      });
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentLevel, setCurrentLevel] = useState("district"); // Can be "district", "subdivision", "block"
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedDistrictName, setSelectedDistrictName] = useState(null);
  const [selectedSubDivision, setSelectedSubDivision] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [selectedPanchayat, setSelectedPanchayat] = useState(null);
  const [data, setData] = useState([]);
  const [totalShops, setTotalShops] = useState([]);


  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  // Static values for shops
  const [inspectedShops, setInspectedShops] = useState(0); // Static value for inspected shops
  const [pendingShops, setPendingShops] = useState(0);    // Static value for pending shops

  // Calculate percentages
  const inspectedPercentage = ((inspectedShops / totalShops) * 100).toFixed(2);
  const pendingPercentage = ((pendingShops / totalShops) * 100).toFixed(2);

  const [totalInspections, setTotalInspections] = useState(0);  // Changed initial state to null


  // Default to today's date
  const [subDivisions, setSubDivisions] = useState([]);  // Initialize as an empty array
  const [blocks, setBlocks] = useState([]);  // Initialize as an empty array
  const [selectedDate, setSelectedDate] = useState(""); // State for selected date
  const [panchayats, setPanchayats] = useState('');
  useEffect(() => {
    // Set selectedDate to the first day of the current month when the component mounts
    const date = new Date();
    const currentMonthFirstDay = new Date(date.getFullYear(), date.getMonth(), 2).toISOString().slice(0, 10);
    setSelectedDate(currentMonthFirstDay);
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  const handleEndDateIconClick = () => {
    // Only show the calendar for endDate if startDate is selected
    if (startDate) {
      setShowEndCalendar(true);
    }
  };

  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
  // Determine the minimum date for the endDate date picker
  const currentYear = currentDate.getFullYear();
  const minStartDate = new Date(currentYear, 0, 1); // January 1st of current year

  const [apiData, setApiData] = useState(null); // Hold the fetched data

  const [period, setPeriod] = useState("Current Month");
  const [dataUserInspection, setDataUserInspection] = useState({
    "Current Month": [
      { count: 0, label: "Ongoing QC-CMR Inspections",color: "#6495ED" },
      { count: 0, label: "Completed QC-CMR Inspections",  color: "#40E0D0" },
      { count: 0, label: "Not Inspected",  color: "#ff9248" },
      { count: 0, label: "Total QC-CMR",  color: "#CCCCFF" }

    ],
    "Last 3 Months": [
      { count: 0, label: "Ongoing QC-CMR Inspections",color: "#6495ED" },
      { count: 0, label: "Completed QC-CMR Inspections",  color: "#40E0D0" },
      { count: 0, label: "Not Inspected",  color: "#ff9248" },
      { count: 0, label: "Total QC-CMR",  color: "#CCCCFF" }
    ],
    "Last 6 Months": [
      { count: 0, label: "Ongoing QC-CMR Inspections",color: "#6495ED" },
      { count: 0, label: "Completed QC-CMR Inspections",  color: "#40E0D0" },
      { count: 0, label: "Not Inspected",  color: "#ff9248" },
      { count: 0, label: "Total QC-CMR",  color: "#CCCCFF" }
    ],
  });
  const [loading, setLoading] = useState(false);

  // Function to fetch data with optimized logic
  const fetchData = async (from, selectedPeriod) => {
    setLoading(true); // Show loading message when starting to fetch data
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const response = await fetch(`${process.env.REACT_APP_GODOWN_API_URL}/api/godown-dashboard-user-counts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          from,
          username: userData?.username,
          userId: userData?.id,
          surveyType:"3"
        }),
      });

      if (response.ok) {
        const result = await response.json();

        let updatedData = [];
        if (selectedPeriod === "Current Month") {
          updatedData = [
            { label: "Ongoing QC-CMR Inspections", count: result.ongoingInspections, color: "#6495ED" },
            { label: "Completed QC-CMR Inspections", count: result.completedInspections, color: "#40E0D0" },
            { label: "Not Inspected", count: result.notInspected, color: "#ff9248" },
            { label: "Total QC-CMR", count: result.totalGodown, color: "#CCCCFF" }
          ];
        } else {
          updatedData = [
            { label: "Ongoing QC-CMR Inspections", count: result.ongoingInspections, color: "#6495ED" },
            { label: "Completed QC-CMR Inspections", count: result.completedInspections, color: "#40E0D0" },
            { label: "Not Inspected", count: result.notInspected, color: "#ff9248" },
            { label: "Total QC-CMR", count: result.totalGodown, color: "#CCCCFF" }
          ];
        }

        // Update the state for the selected period
        setDataUserInspection((prevData) => ({ ...prevData, [selectedPeriod]: updatedData }));
      } else {
        console.error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Hide loading message once data is fetched or if an error occurs
    }
  };

  // Handle when the user selects a different period
  const getDateRange = (e) => {
    let selectedPeriod = e.target.value;
    setPeriod(selectedPeriod); // Update the period state

    const today = new Date();
    let fromDate;

    // Calculate the 'from' date based on the selected period
    if (selectedPeriod === "Current Month") {
      fromDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1)); // First day of the current month
    } else if (selectedPeriod === "Last 3 Months") {
      fromDate = new Date(Date.UTC(today.getFullYear(), today.getMonth() - 2, 1)); // First day of 3 months ago
    } else if (selectedPeriod === "Last 6 Months") {
      fromDate = new Date(Date.UTC(today.getFullYear(), today.getMonth() - 5, 1)); // First day of 6 months ago
    }

    //Format to YYYY-MM-DD
    const from = fromDate.toISOString().slice(0, 10);
    fetchData(from, selectedPeriod); // Fetch data based on the selected period
  };

  // Initial useEffect to set fromDate to the first day of the current month
  useEffect(() => {
    const today = new Date();
    const fromDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1)); // UTC set to first day of current month
    fetchData(fromDate.toISOString().slice(0, 10), period); // Initial data fetch with "Current Month"
  }, []);


  const barOptions = {
    plugins: {
      datalabels: { display: false },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { display: false },
      },
      y: {
        grid: { display: false },
        ticks: { stepSize: 500000 },
        max: 5000000,
      },
    },
    responsive: true,
    onClick: () => {
      // Retrieve formattedFromDate (should be available in your scope)
      const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
      const formattedToDate = localStorage.getItem('formateedToDateForQtl');

      // console.log('formattedFromDate  redirect quantity', formattedFromDate);
      //console.log("formated to to redirect page", formattedToDate);
      if (formattedFromDate && formattedToDate) {
        // Store the date in localStorage and open the Deviation page
        window.open('/deviation', '_blank');
      } else {
        console.error('No formattedFromDate available');
      }
    },
  };


  const stockQuantityData = {
    labels: ['', ''], // Labels for the X-axis
    datasets: [
      {
        label: 'ePOS Stock', // Label for ePOS Stock
        data: [apiData?.stockDeviation?.ePosStock], // Use optional chaining
        backgroundColor: '#3ec79b', // Color for the ePOS Stock
      },

      {
        label: 'Physical Stock', // Label for Physical Stock
        data: [apiData?.stockDeviation?.physicalStock], // Use optional chaining
        backgroundColor: '#FA8072', // Color for the Physical Stock            
      },
    ],
  };
  const handleBatteryClick = (data) => {

    // const newWindow = window.open(`/battery-details/${data.label}`, '_blank');
    // localStorage.setItem('batteryBackupLabel', data.label);

    // if (newWindow) {

    //   newWindow.localStorage.setItem('batteryBackupData', JSON.stringify(data));
    // } else {
    //   console.error('Failed to open new window');
    // }
  };


  const calculateBatteryBackupPercentages = (batteryBackUpData) => {
    // Sum all the values
    const totalBatteryBackup =
      batteryBackUpData.backup0To1 + batteryBackUpData.backup1To2 +
      batteryBackUpData.backup2To3 + batteryBackUpData.backup3To4;

    // If total is 0, return 0 for all percentages to avoid division by 0
    if (totalBatteryBackup === 0) {
      return [
        { label: '0-1 Hrs', percentage: '0.00', color: '#FA8072' },
        { label: '1-2 Hrs', percentage: '0.00', color: '#f7d681' },
        { label: '2-3 Hrs', percentage: '0.00', color: '#f7d681' },
        { label: '3-4 Hrs', percentage: '0.00', color: '#3ec79b' }
      ];
    }

    // Calculate the percentage for each category and round it to 2 decimal places
    const percentage_0To1Hrs = ((batteryBackUpData.backup0To1 / totalBatteryBackup) * 100).toFixed(2);
    const percentage_1To2Hrs = ((batteryBackUpData.backup1To2 / totalBatteryBackup) * 100).toFixed(2);
    const percentage_2To3Hrs = ((batteryBackUpData.backup2To3 / totalBatteryBackup) * 100).toFixed(2);
    const percentage_3To4Hrs = ((batteryBackUpData.backup3To4 / totalBatteryBackup) * 100).toFixed(2);

    return [
      { label: '0-1 Hrs', percentage: percentage_0To1Hrs, color: '#FA8072' },
      { label: '1-2 Hrs', percentage: percentage_1To2Hrs, color: '#f87205' },
      { label: '2-3 Hrs', percentage: percentage_2To3Hrs, color: '#f7d681' },
      { label: '3-4 Hrs', percentage: percentage_3To4Hrs, color: '#3ec79b' },
    ];
  };


  // Custom styling for horizontal progress bars
  const customStyle = {
    progressBarContainer: {
      display: 'flex',
      flexDirection: 'column', // Stack bars vertically
      gap: '20px',
      width: '100%',

    },
    progressBar: {
      height: '14px', // Height of the horizontal bars
      width: '95%', // Full width container
      backgroundColor: '#e0e0e0', // Light gray background for the bar
      borderRadius: '25px', // Rounded corners (curved borders for pole effect)
      // position: 'relative',
      marginLeft: '2.5%',
      marginTop: '15%',

    },
    progressBarFilled: {
      height: '100%', // Full height of the container
      borderRadius: '25px', // Rounded corners for the filled part

    },
    label: {
      // position: 'absolute',
      marginTop: '1.5%',
      fontSize: '12px',
      color: 'gray',

    },
    percentage: {
      // position: 'absolute',
      fontSize: '12px',
      color: 'gray',

      marginLeft: '77.5%',
      marginTop: '-9.5%',
    },
  };

  // Options for the chart to show "Yes" or "No" labels above the bars
  const equipmentDatabarOptions = {
    plugins: {
      legend: { display: false }, // Hide the legend
      datalabels: {
        display: true, // Enable data labels
        color: '#000', // Set the text color (black)
        font: {
          weight: 'bold', // Make the font bold
          size: 12, // Font size for the text
        },
        formatter: function (value, context) {
          const datasetLabel = context.dataset.label;
          // Display 'Yes' or 'No' based on dataset label
          if (datasetLabel === 'Verified Equipment') {
            return value > 0 ? `Yes` : ''; // Show "Yes" and percentage for 'Verified Equipment'
          } else if (datasetLabel === 'Not Verified Equipment') {
            return value > 0 ? `No` : ''; // Show "No" and percentage for 'Not Verified Equipment'
          }
          return '';
        },
        anchor: 'end', // Anchor the label at the top of the bar
        align: 'end', // Align the label to the top of the bar
        offset: 2, // Adjust the position slightly above the bar
      },
      tooltip: {
        enabled: true, // Ensure tooltips are enabled
        callbacks: {
          label: function (tooltipItem) {
            // Format the tooltip label to add the % symbol
            const value = tooltipItem.raw; // Get the value of the tooltip item
            const datasetLabel = tooltipItem.dataset.label; // Get the label of the dataset (e.g., 'Verified Equipment')
            return `${datasetLabel}: ${value}%`; // Append "%" to the value // Append % to the tooltip value
          }
        }
      },
    },
    scales: {
      x: {
        grid: { display: false }, // Remove x-axis line
        ticks: { display: false }, // Hide the ticks on the x-axis
      },
      y: {
        grid: { display: false }, // Remove y-axis grid lines
        ticks: { display: false }, // Hide the ticks on the y-axis
        display: false, // Hide the y-axis line
        max: 110, // Set max value to 100 for percentage scale
      },
    },
    responsive: true, // Make the chart responsive
    onClick: () => {
      // Retrieve formattedFromDate (should be available in your scope)
      const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
      const formattedToDate = localStorage.getItem('formateedToDateForQtl');

      // console.log('formattedFromDate  redirect quantity', formattedFromDate);
      // console.log("formated to to redirect page", formattedToDate);
      if (formattedFromDate && formattedToDate) {
        // Store the date in localStorage and open the Deviation page
        window.open('/QC-CMRMeasuringEquipment', '_blank');
      } else {
        console.error('No formattedFromDate available');
      }
    },
  };

  // Function to calculate the percentage for "Yes" and "No" responses
  const calculateYesNoPercentages = (yesCount, noCount) => {
    // Calculate total responses
    const total = yesCount + noCount;

    // If total is 0, return 0 for both percentages to avoid division by 0
    if (total === 0) {
      return {
        yesPercentage: '0.00',
        noPercentage: '0.00'
      };
    }

    // Calculate the percentage for Yes and No
    const yesPercentage = ((yesCount / total) * 100).toFixed(2);
    const noPercentage = ((noCount / total) * 100).toFixed(2);

    return { yesPercentage, noPercentage };
  };

  // Extract the "Yes" and "No" values for measuring equipment verified
  const measuringEquipmentYesCount = apiData?.measuringEquipmentVerified?.yes || 0;
  const measuringEquipmentNoCount = apiData?.measuringEquipmentVerified?.no || 0;

  // Log the values
  //console.log("Measuring Equipment - Yes Count:", measuringEquipmentYesCount);
  //console.log("Measuring Equipment - No Count:", measuringEquipmentNoCount);

  // Calculate percentages for measuring equipment verified
  const { yesPercentage: measuringEquipmentYesPercentage, noPercentage: measuringEquipmentNoPercentage } =
    calculateYesNoPercentages(measuringEquipmentYesCount, measuringEquipmentNoCount);

  // Log calculated percentages
  //console.log('Measuring Equipment - Yes Percentage:', `${measuringEquipmentYesPercentage}%`);
  //console.log('Measuring Equipment - No Percentage:', measuringEquipmentNoPercentage);

  // Set up the data for the Measuring Equipment Verified Bar Chart
  const equipmentData = {
    labels: ['', '', ''], // Empty labels to remove X-axis labels
    datasets: [
      {
        label: 'Verified Equipment',
        data: [0, measuringEquipmentYesPercentage], // Only showing the 'Yes' value as a percentage
        backgroundColor: '#3ec79b', // Color for "Yes" (Verified)
      },
      {
        label: 'Not Verified Equipment',
        data: [0, measuringEquipmentNoPercentage], // Only showing the 'No' value as a percentage
        backgroundColor: '#FA8072', // Color for "No" (Not Verified)
      },
    ],
  };

  //console.log('Measuring Equipment Data for Chart:', equipmentData);


  // Function to calculate the percentage for "Yes" and "No" responses
  const calculateYesNoEqu = (yesCountEqu, noCountEqu) => {
    // Ensure that the counts are valid numbers
    yesCountEqu = isNaN(yesCountEqu) ? 0 : yesCountEqu;
    noCountEqu = isNaN(noCountEqu) ? 0 : noCountEqu;

    // Calculate total responses
    const total = yesCountEqu + noCountEqu;

    // If total is 0, return 0 for both percentages to avoid division by 0
    if (total === 0) {
      return {
        yesPercentageEqu: 0,
        noPercentageEqu: 0
      };
    }

    // Calculate the percentage for Yes and No
    const yesPercentageEqu = ((yesCountEqu / total) * 100).toFixed(2);
    const noPercentageEqu = ((noCountEqu / total) * 100).toFixed(2);

    return { yesPercentageEqu, noPercentageEqu };
  };

  // Extract the "Yes" and "No" values for grievance register availability
  const grievanceYesCount = apiData?.grievanceRegisterAvailable?.yes || 0;
  const grievanceNoCount = apiData?.grievanceRegisterAvailable?.no || 0;

  // Log the values for debugging
  //console.log("Grievance Register - Yes Count:", grievanceYesCount);
  //console.log("Grievance Register - No Count:", grievanceNoCount);

  // Calculate percentages for grievance register availability
  const { yesPercentageEqu: grievanceYesPercentage, noPercentageEqu: grievanceNoPercentage } =
    calculateYesNoEqu(grievanceYesCount, grievanceNoCount);

  // Log calculated percentages for debugging
  //console.log('Grievance Register - Yes Percentage:', grievanceYesPercentage);
  //console.log('Grievance Register - No Percentage:', grievanceNoPercentage);

  // Set up the data for the Grievance Register Availability Bar Chart
  const grievanceData = {
    labels: ['', '', ''], // Empty labels to remove X-axis labels
    datasets: [
      {
        label: 'Available',
        data: [0, parseFloat(`${grievanceYesPercentage}`)], // Only showing the 'Yes' value as a percentage
        backgroundColor: '#3ec79b', // Color for Available (Yes)
      },
      {
        label: 'Not Available',
        data: [0, parseFloat(grievanceNoPercentage)], // Only showing the 'No' value as a percentage
        backgroundColor: '#FA8072', // Color for Not Available (No)
      },
    ],
  };

  //console.log('Grievance Register Data for Chart:', grievanceData);


  // Chart options to show percentage and labels ("Yes" or "No") above the bars
  const grievanceDatabarOptions = {
    plugins: {
      legend: { display: false }, // Hide legend
      datalabels: {
        display: true, // Enable datalabels
        color: '#000', // Set text color to black
        font: {
          weight: 'bold', // Make the font bold
          size: 12, // Font size for the text
        },
        formatter: function (value, context) {
          const datasetLabel = context.dataset.label;

          // Only show "Yes" or "No" if the percentage is not 0%
          const percentage = value.toFixed(1); // Round to 1 decimal point
          if (percentage === '0.0') {
            return ''; // Do not display anything if the percentage is 0%
          }

          if (datasetLabel === 'Available') {
            return `Yes`; // For 'Available', show "Yes" with percentage
          } else if (datasetLabel === 'Not Available') {
            return `No`; // For 'Not Available', show "No" with percentage
          }
          return '';
        },
        anchor: 'end', // Anchor label to the end (top of the bar)
        align: 'end', // Align label at the end (top of the bar)
        offset: 2, // Adjust the position slightly above the bar
      },
      tooltip: {
        enabled: true, // Ensure tooltips are enabled
        callbacks: {
          label: function (tooltipItem) {
            // Format the tooltip label to add the % symbol
            const value = tooltipItem.raw; // Get the value of the tooltip item
            const datasetLabel = tooltipItem.dataset.label; // Get the label of the dataset (e.g., 'Verified Equipment')
            return `${datasetLabel}: ${value}%`; // Append "%" to the value // Append % to the tooltip value
          }
        }
      },
    },
    scales: {
      x: {
        grid: { display: false }, // Remove x-axis line
        ticks: { display: false }, // Hide the ticks on the x-axis
      },
      y: {
        grid: { display: false }, // Remove y-axis grid lines
        ticks: { display: false }, // Hide the ticks on the y-axis
        display: false, // Hide the y-axis line
        max: 110, // Set max value to 100 for percentage scale
      },
    },
    responsive: true, // Make the chart responsive
    onClick: () => {
      // Retrieve formattedFromDate (should be available in your scope)
      const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
      const formattedToDate = localStorage.getItem('formateedToDateForQtl');

      //console.log('formattedFromDate  redirect quantity', formattedFromDate);
      // console.log("formated to to redirect page", formattedToDate);
      if (formattedFromDate && formattedToDate) {
        // Store the date in localStorage and open the Deviation page
        window.open('/QC-CMRGrievanceRegister', '_blank');
      } else {
        console.error('No formattedFromDate available');
      }
    },

  };


  // Custom styles for each section
  const customStyleQuantity = {
    progressBarContainer: {
      display: 'flex',
      flexDirection: 'column', // Stack bars vertically
      gap: '20px', // Space between bars
    },
    progressBar: {
      height: '14px', // Height of the horizontal bars
      width: '95%', // Full width container
      backgroundColor: '#e0e0e0', // Light gray background for the bar
      borderRadius: '25px', // Rounded corners (curved borders for pole effect)
      // position: 'relative',
      marginLeft: '2.5%',
      marginTop: '2%',
    },
    progressBarFilled: {
      height: '100%', // Full height of the container
      borderRadius: '25px', // Rounded corners for the filled part
    },
    label: {
      // position: 'absolute',
      fontSize: '12px',
      marginLeft: '2.5%',
    },
    percentage: {
      // position: 'absolute',
      right: '20px',
      marginLeft: '77.5%',
      marginTop: '-7.5%',

      fontSize: '12px',
      color: 'gray', // White color for the percentage text
    },
  };

  const customStyleQunality = {
    progressBarContainer: {
      display: 'flex',
      flexDirection: 'column', // Stack bars vertically
      gap: '20px', // Space between bars
    },
    progressBar: {
      height: '14px', // Height of the horizontal bars
      width: '95%', // Full width container
      backgroundColor: '#e0e0e0', // Light gray background for the bar
      borderRadius: '25px', // Rounded corners (curved borders for pole effect)
      // position: 'relative',
      marginLeft: '2.5%',
      marginTop: '2%',
    },
    progressBarFilled: {
      height: '100%', // Full height of the container
      borderRadius: '25px', // Rounded corners for the filled part
    },
    label: {
      // position: 'absolute',
      fontSize: '12px',
      marginLeft: '2.5%',
    },
    percentage: {
      // position: 'absolute',
      right: '20px',
      marginLeft: '77.5%',
      marginTop: '-7.5%',
      fontSize: '12px',
      color: 'gray', // White color for the percentage text
    },
  };

  const customStyleLicense = {
    progressBarContainer: {
      display: 'flex',
      flexDirection: 'column', // Stack bars vertically
      gap: '20px', // Space between bars
    },
    progressBar: {
      height: '14px', // Height of the horizontal bars
      width: '95%', // Full width container
      backgroundColor: '#e0e0e0', // Light gray background for the bar
      borderRadius: '25px', // Rounded corners (curved borders for pole effect)
      // position: 'relative',
      marginLeft: '2.5%',
      marginTop: '2%',
    },
    progressBarFilled: {
      height: '100%', // Full height of the container
      borderRadius: '25px', // Rounded corners for the filled part
    },
    label: {
      // position: 'absolute',
      fontSize: '12px',
      marginLeft: '2.5%',
    },
    percentage: {
      // position: 'absolute',
      right: '20px',
      marginLeft: '77.5%',
      marginTop: '-7.5%',

      fontSize: '12px',
      color: 'gray', // White color for the percentage text
    },
  };
  // Food Grain Quantity Data
  const handleQuantityFoodGrainClick = () => {
    // Retrieve formattedFromDate (should be available in your scope)
    const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
    const formattedToDate = localStorage.getItem('formateedToDateForQtl');

    //('formattedFromDate quantity', formattedFromDate);
    //console.log("formated to to redirect page", formattedToDate);
    if (formattedFromDate && formattedToDate) {
      // Store the date in localStorage and open the Deviation page
      window.open('/QC-CMRElectricityConnection', '_blank');
    } else {
      console.error('No formattedFromDate available');
    }
  };

  // Extract the values for quantityOfFoodGrain from apiData
  const quantityOfFoodGrainRaw = apiData?.electricityConnection || {
    'yes': 0,
    'no': 0,
  };

  // Calculate the total for quantityOfFoodGrain
  const totalQuantityOfFoodGrain = quantityOfFoodGrainRaw['yes'] + quantityOfFoodGrainRaw['no'];

  // Calculate the percentage for each category (Proper and Less) and round it to 2 decimal places
  const percentageProper = totalQuantityOfFoodGrain ? ((quantityOfFoodGrainRaw['yes'] / totalQuantityOfFoodGrain) * 100).toFixed(2) : '0.00';
  const percentageLess = totalQuantityOfFoodGrain ? ((quantityOfFoodGrainRaw['no'] / totalQuantityOfFoodGrain) * 100).toFixed(2) : '0.00';

  // Prepare the quantity of food grain data with the percentages
  const quantityOfFoodGrain = [
    { label: 'Yes', percentage: percentageProper, color: '#3ec79b' },
    { label: 'No', percentage: percentageLess, color: '#FA8072' },
  ];

  //console.log(quantityOfFoodGrain); // Check the output

  const handleQualityFoodGrainClick = () => {
    // Retrieve formattedFromDate (should be available in your scope)
    const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
    if (formattedFromDate) {
      // Store the date in localStorage and open the Deviation page
      window.open('/QC-CMRWeighMachineAvailable', '_blank');
    } else {
      console.error('No formattedFromDate available');
    }
  };
  // Extract the values for qualityOfFoodGrain from apiData
  const qualityOfFoodRaw = apiData?.weighMachineAvailable || {
    'good': 0,
    'bad': 0,
  };

  // Calculate the total for qualityOfFoodGrain
  const totalQualityOfFood = qualityOfFoodRaw['yes'] + qualityOfFoodRaw['no'];

  // Calculate the percentage for each category (Good and Bad) and round it to 2 decimal places
  const percentageGood = totalQualityOfFood ? ((qualityOfFoodRaw['yes'] / totalQualityOfFood) * 100).toFixed(2) : '0.00';
  const percentageBad = totalQualityOfFood ? ((qualityOfFoodRaw['no'] / totalQualityOfFood) * 100).toFixed(2) : '0.00';

  // Prepare the quality of food data with the percentages
  const qualityOfFood = [
    { label: 'Yes', percentage: percentageGood, color: '#3ec79b' },
    { label: 'No', percentage: percentageBad, color: '#FA8072' },
  ];

  // console.log(qualityOfFood); // Check the output

  const handleLicensedSiteClick = () => {
    // Retrieve formattedFromDate (should be available in your scope)
    const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
    const formattedToDate = localStorage.getItem('formateedToDateForQtl');

    //console.log('formattedFromDate  redirect quantity', formattedFromDate);
    //console.log("formated to to redirect page", formattedToDate);
    if (formattedFromDate && formattedToDate) {
      // Store the date in localStorage and open the Deviation page
      window.open('/QC-CMRLicensedSite', '_blank');
    } else {
      console.error('No formattedFromDate available');
    }
  };
  // Extract the values for licencesSiteCompliance from apiData
  const licensedSiteComplianceRaw = apiData?.cctvAvailable || {
    'yes': 0,
    'no': 0,
  };

  // Calculate the total for licensedSiteCompliance
  const totalLicensedSiteCompliance = licensedSiteComplianceRaw['yes'] + licensedSiteComplianceRaw['no'];

  // Calculate the percentage for each category (Yes and No) and round it to 2 decimal places
  const percentageYes = totalLicensedSiteCompliance
    ? ((licensedSiteComplianceRaw['yes'] / totalLicensedSiteCompliance) * 100).toFixed(2)
    : '0.00';

  const percentageNo = totalLicensedSiteCompliance
    ? ((licensedSiteComplianceRaw['no'] / totalLicensedSiteCompliance) * 100).toFixed(2)
    : '0.00';

  // Prepare the data for rendering the licensed site compliance chart
  const licensedSiteCompliance = [
    { label: 'Yes', percentage: percentageYes, color: '#3ec79b' },
    { label: 'No', percentage: percentageNo, color: '#FA8072' },
  ];

  // Log the final result to check
  //console.log(licensedSiteCompliance);



  // Data for Pie Chart
  const pieData = {
    labels: [
      ` (${pendingPercentage}%)`,
      ` (${inspectedPercentage}%)`
    ],
    datasets: [
      {
        data: [pendingShops, inspectedShops], // Data for the pie chart totalInspections
        backgroundColor: ['#d21300', '#2a6d8b'], // Reversed background colors
        hoverBackgroundColor: ['#d21300', '#2a6d8b'], // Reversed hover colors
      },
    ],
  };

  const pieOptions = {
    responsive: true,  // Ensure it’s responsive to different screen sizes
    plugins: {
      tooltip: {
        enabled: false,  // Disable the tooltip completely
      },
      datalabels: {
        display: true,  // Always display the data labels
        color: '#fff',  // Color of the text inside the Pie chart
        formatter: (value, context) => {
          // If you want to display the number of inspected shops inside the Pie chart
          if (context.datasetIndex === 1) {
            return inspectedShops.toLocaleString();  // Show the number of inspected shops inside the Pie chart
          } else {
            return value.toLocaleString();  // For pending shops, show the corresponding number
          }
        },
        font: {
          size: 12,
        },
        align: 'center',  // Center the text inside the pie chart
        anchor: 'center',  // Anchor the text to the center of the pie
      },
    },
    rotation: Math.PI,  // Rotates the chart by 180 degrees (π radians)
  };

  const [currentDateTime, setCurrentDateTime] = useState({
    date: '',
    time: '',
  });
  const token = `${process.env.REACT_APP_BEFORE_TOKEN}`;
  const baseUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api/godown-home-page`;  // Define the base URL
  const getHomePageBarsData = useCallback((from, to) => {
    if (token) {
      axios.post(baseUrl, { from, to,surveyType:"3" }, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => {
          if (response.data) {
            setApiData(response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching API:", error);
        });
    }
  }, [token]); // Remove debounce to test

  useEffect(() => {
    const now = new Date();
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 2);
    const formattedFromDate = firstDayOfMonth.toISOString().slice(0, 10); // e.g., "2025-04-01"
    const formattedToDate = now.toISOString().slice(0, 10); // e.g., "2025-04-04"
    const showStartdate = new Date(now.getFullYear(), now.getMonth(), 1)
    const shoeendDate = now;
    setStartDate(showStartdate);
    setEndDate(shoeendDate);
    // Fetch data for the current month on page load
    getDistrictWiseData(formattedFromDate, formattedToDate);
    localStorage.setItem('formattedFromDateForQtl', formattedFromDate);
    localStorage.setItem('formateedToDateForQtl', formattedToDate)
    // console.log("formared set date formmattedFromDate ",formattedFromDate)
    // console.log("formared set date formmattedFromDate",formattedToDate)
    getHomePageBarsData(formattedFromDate, formattedToDate);
  }, []);


  const getDistrictWiseData = (fromDate, toDate) => {
     axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/qc-dashboard-data/surveyType/1/QcType/3/from/${fromDate}/to/${toDate}`)
     // axios.get(`http://localhost:8080/reports/godown-home-data/surveyType/2/from/${fromDate}/to/${toDate}`)
      .then((response) => {
        setData(response.data.sort((a, b) => a.districtName.localeCompare(b.districtName)));

        const totals = response.data.reduce(
          (acc, item) => {
            acc.totalGodowns += item.totalGodowns;
            acc.godownsInspected += item.godownsInspected;
            acc.totalInspections += item.totalInspections;
            acc.godownsPending += item.godownsPending;
            return acc;
          },
          { totalGodowns: 0, godownsInspected: 0, godownsPending: 0, totalInspections: 0 }
        );

        setInspectedShops(totals.godownsInspected);
        setPendingShops(totals.godownsPending);
        setTotalShops(totals.totalGodowns);
        setTotalInspections(totals.totalInspections);
      })
      .catch((error) => {
        console.error("Error fetching district-wise data", error);
      });
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setShowCalendar(false); // Hide the calendar after date selection
    setEndDate('');
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setShowEndCalendar(false); // Hide the calendar after date selection

    if (startDate && date) {
      // Call APIs only if both dates are selected
      const formattedFromDate = format(startDate, 'yyyy-MM-dd');
      const formattedToDate = format(date, 'yyyy-MM-dd');
      localStorage.setItem('formattedFromDateForQtl', formattedFromDate);
      localStorage.setItem('formateedToDateForQtl', formattedToDate)
      //console.log("formared set date formmattedFromDate ", formattedFromDate)
      //console.log("formared set date formmattedFromDate", formattedToDate)
      getHomePageBarsData(formattedFromDate, formattedToDate);
      getDistrictWiseData(formattedFromDate, formattedToDate);
    }
  };


  useEffect(() => {
    // axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/today-count`)
    //   .then((response) => {
    //     setTotalInspections(response.data); // Set the total inspections count from backend
    //   })
    //   .catch((error) => {
    //     console.error("There was an error fetching today's count!", error);
    //   });

    let date = new Date();
    date.setDate(1);  // Set to the first day of the current month

    // Update the current date and time every minute
    const updateDateTime = () => {
      const now = new Date();
      const day = now.getDate().toString().padStart(2, '0'); // Adds leading zero if needed
      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
      const year = now.getFullYear().toString().slice(); // Get the last two digits of the year

      const formattedDate = `${day}-${month}-${year}`;
      let formattedTime = now.toLocaleTimeString('en-GB', {
        hour12: true,
        hour: '2-digit',
        minute: '2-digit',
      });
      formattedTime = formattedTime.replace(/\s(am|pm)/, (match) => match.toUpperCase());

      setCurrentDateTime({
        date: formattedDate,
        time: formattedTime,
      });
    };
    updateDateTime();
    const interval = setInterval(updateDateTime, 60000); // Update every minute
    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);



  // If API data hasn't loaded yet, you can return a loading indicator or placeholder
  if (!apiData) {
    return <div className='loading-message' style={{
      position: 'absolute',
      top: '30%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center'
    }}>Loading...</div>;
  }



  const downloadPDF = () => {
    const doc = new jsPDF();

    doc.addImage(pds, 'jpeg', 9.5, 10, 190, 30); // Image format: 'JPEG'

    let yPosition = 45; // Starting Y position
    let tableData = []; // This will hold the data for the table
    let title = ''; // This will hold the title for the PDF
    let totalGodowns = 0, totalInspections = 0, godownsInspected = 0, godownsPending = 0; // Variables to accumulate totals


    // Set the font to bold for title
    doc.setFont("helvetica", "bold");
    const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
    const formattedToDate = localStorage.getItem('formateedToDateForQtl');
    // Determine which level of data to include
    if (currentLevel === "district") {
      title = `District Wise QC-CMR Inspection Report`;

      // Add title to the PDF
      doc.text(title, 14, yPosition);
      yPosition += 10; // Adjust the yPosition for the date range below the title

      // Format the date range text
      doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);

      // Set font to normal for the date range and add it below the title
      doc.setFont("helvetica", "normal");
      yPosition += 10; // Move the position down for the table

      // Populate the tableData for district level
      tableData = filteredData.map((row, index) => {
        totalGodowns += row.totalGodowns;
        totalInspections += row.totalInspections;
        godownsInspected += row.godownsInspected;
        godownsPending += row.godownsPending;

        return [
          index + 1,
          capitalizeFirstLetter(row.districtName),
          formatNumber(row.totalGodowns),
          formatNumber(row.totalInspections),
          formatNumber(row.godownsInspected),
          formatNumber(row.godownsPending),
          `${row.percentage}%`
        ];
      });
    } else if (currentLevel === "subdivision") {
      title = `${capitalizeFirstLetter(selectedDistrictName)} - Subdivision Wise QC-CMR Inspection Report`;

      // Add title to the PDF
      doc.text(title, 14, yPosition);
      yPosition += 10; // Adjust the yPosition for the date range below the title

      // Format the date range text
      doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
      // Set font to normal for the date range and add it below the title
      doc.setFont("helvetica", "normal");
      yPosition += 10; // Move the position down for the table

      // Populate the tableData for subdivision level
      tableData = filteredData?.map((subdivision, index) => {
        totalGodowns += subdivision.totalGodowns;
        totalInspections += subdivision.totalInspections;
        godownsInspected += subdivision.godownsInspected;
        godownsPending += subdivision.godownsPending;
        
        return [
          index + 1,
          capitalizeFirstLetter(subdivision.subdivisionName),
          formatNumber(subdivision.totalGodowns),
          formatNumber(subdivision.totalInspections),
          formatNumber(subdivision.godownsInspected),
          formatNumber(subdivision.godownsPending),
          `${subdivision.percentage}%`
        ];
      });
    } else if (currentLevel === "block") {
      title = `${capitalizeFirstLetter(selectedDistrictName)} - ${capitalizeFirstLetter(selectedSubDivision)} - Block Wise QC-CMR Inspection Report`;

      // Add title to the PDF
      doc.text(title, 14, yPosition);
      yPosition += 10; // Adjust the yPosition for the date range below the title

      // Format the date range text
      doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);
      // Set font to normal for the date range and add it below the title
      doc.setFont("helvetica", "normal");
      yPosition += 10; // Move the position down for the table

      // Populate the tableData for block level
      tableData = blocks?.map((block, index) => {
        totalGodowns += block.totalGodowns;
        totalInspections += block.totalInspections;
        godownsInspected += block.godownsInspected;
        godownsPending += block.godownsPending;

   
        return [
          index + 1,
          capitalizeFirstLetter(block.blockName),
          formatNumber(block.totalGodowns),
          formatNumber(block.totalInspections),
          formatNumber(block.godownsInspected),
          formatNumber(block.godownsPending),
          `${block.percentage}%`
        ];
      });
    }

    yPosition += 5; // Ensure space between the title/date range and the table

    // Get the current date and time
    const currentDate = new Date();

    // Format the date as DD-MM-YYYY
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

    // Format the time as HH:mm:ss
    const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

    // Combine both date and time into one string
    const formattedDateTime = `${formattedDate} ${formattedTime}`;

    // Set the date text color (black) and make it bold
    doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
    doc.setTextColor(0, 0, 0);  // Black color for the date
    doc.setFontSize(12);

    // Add the current date and time to the PDF, positioned at the bottom-right corner
    doc.text(`Report Date: ${formattedDateTime}`, 195, yPosition, { align: 'right' });

    // Update yPosition to create space after the date
    yPosition += 5;
    // Table header based on the current level
    let header;
    if (currentLevel === "district") {
      header = [['S.No', 'District', 'Total No. of CMR Godowns', 'No. Of CMR Inspections by QC', 'No. of CMR Godowns Inspected ', 'No. of CMR Godowns Pending ', '% of CMR Godowns Inspected by QC']];
    } else if (currentLevel === "subdivision") {
      header = [['S.No', 'Sub-Division', 'Total No. of CMR Godowns', 'No. Of CMR Inspections by QC', 'No. of CMR Godowns Inspected ', 'No. of CMR Godowns Pending', '% of CMR Godowns Inspected QC']];
    } else if (currentLevel === "block") {
      header = [['S.No', 'Block', 'Total No. of CMR Godowns', 'No. Of CMR Inspections by QC', 'No. of CMR Godowns Inspected ', 'No. of CMR Godowns Pending ', '% of CMR Godowns Inspected by QC']];
    }

    // Adding the table with dynamic header and data
    doc.autoTable({
      startY: yPosition, // Start the table below the title and date range
      head: header, // Dynamically set the header based on the current level
      body: [...tableData, [  // Append the total row to the table body
        '',  // Empty cell for serial number
        'Total',  // Total label
        formatNumber(totalShops),
        formatNumber(totalInspections),
        formatNumber(inspectedShops),
        formatNumber(pendingShops),
        ((inspectedShops / totalShops) * 100).toFixed(2) + '%'  // Percentage of shops inspected
      ]],
      headStyles: {
        fillColor: [255, 165, 0],
        textColor: [255, 255, 255],  // Text color: White
        fontSize: 10,
        halign: 'center',  // Center header text
      },
      styles: {
        fontSize: 9,
        halign: 'center',  // Align text in the middle by default
      },
      columnStyles: {
        1: { halign: 'left' }, // Column index 1 (Name) aligned to left
        2: { halign: 'right' }, // Total No. of FP Shops
        3: { halign: 'right' }, // No. of Shops Inspected
        4: { halign: 'right' }, // No. of Inspections
        5: { halign: 'right' }, // No. of Shops Pending
        6: { halign: 'right' }, // Percentage of Shops Inspected
      },
      didParseCell: (data) => {
        // Apply background color and text color for the total row
        if (data.row.index === tableData.length) {  // The last row is the total row
          data.cell.styles.fillColor = [12, 92, 108];  // Dark blue background
          data.cell.styles.textColor = [255, 255, 255];  // White text
          data.cell.styles.fontSize = 10;
        }
      },
    });

    // Save PDF with the dynamic title as filename
    doc.save(`${title.replace(/ /g, '_').replace(/[^a-zA-Z0-9_]/g, '')}.pdf`);
  };


  const downloadExcel = async () => {
    // 2. Generate Excel file using ExcelJS

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Inspection History');


    worksheet.mergeCells('A1:G1'); // Merge cells for the title
    worksheet.getCell('A1').value = 'Inspection Report';
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'FF2A6D8B' } };  // Text color: Light Steel Blue (ARGB format)
    worksheet.getCell('A1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
    };


    let tableData = [];
    let title = '';

    // Determine which level of data to include
    if (currentLevel === "district") {
      title = "District Wise QC-CMR Inspection Report";  // Title for district
      tableData = filteredData.map((row, index) => [
        index + 1,  // S.No (column 1)
        capitalizeFirstLetter(row.districtName),  // District Name (column 2)
        formatNumber(row.totalGodowns),  // Total Shops (column 3)
        formatNumber(row.totalInspections),  // Inspections (column 5)
        formatNumber(row.godownsInspected),  // Inspected Shops (column 4)
        formatNumber(row.godownsPending),  // Pending Shops (column 6)
        `${row.percentage}%`  // Percentage (column 7)
      ]);
    } else if (currentLevel === "subdivision") {
      title = `${capitalizeFirstLetter(selectedDistrictName)} - Subdivision Wise QC-CMR Inspection Report`; // Title for subdivision
      tableData = filteredData?.map((subdivision, index) => [
        index + 1,  // S.No (column 1)
        capitalizeFirstLetter(subdivision.subdivisionName),  // Subdivision Name (column 2)
        formatNumber(subdivision.totalGodowns),
        formatNumber(subdivision.totalInspections),
        formatNumber(subdivision.godownsInspected),
        formatNumber(subdivision.godownsPending),
        `${subdivision.percentage}%`
      ]);
    } else if (currentLevel === "block") {
      title = `${capitalizeFirstLetter(selectedDistrictName)} - ${capitalizeFirstLetter(selectedSubDivision)} - Block Wise QC-CMR Inspection Report`;  // Title for block
      tableData = blocks?.map((block, index) => [
        index + 1,  // S.No (column 1)
        capitalizeFirstLetter(block.blockName),  // Block Name (column 2)
        formatNumber(block.totalGodowns),
        formatNumber(block.totalInspections),
        formatNumber(block.godownsInspected),
        formatNumber(block.godownsPending),
        `${block.percentage}%`
      ]);
    }

    // Add title to the Excel file
    worksheet.getCell('A1').value = title;
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };


    worksheet.mergeCells('A2:G2'); // Merge cells for the title

    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };
    worksheet.getCell('A2').font = { size: 11, bold: true, color: { argb: '000000' } };  // Text color: Light Steel Blue (ARGB format)
    worksheet.getCell('A2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
    };
    const currentDate = new Date();

    // Format the date as DD-MM-YYYY
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

    // Format the time as HH:mm:ss
    const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

    // Combine both date and time into one string
    const formattedDateTime = `${formattedDate} ${formattedTime}`;
    worksheet.getCell('A2').value = `Report Date : ${formattedDateTime}`;
    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };

    const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
    const formattedToDate = localStorage.getItem('formateedToDateForQtl');
    worksheet.getCell('A3').value = `Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}     To Date : ${format(formattedToDate, "dd-MM-yyyy")}`;
    worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };

    worksheet.mergeCells('A3:G3'); // Merge cells for the title

    worksheet.getCell('A3').font = { size: 11, bold: true, color: { argb: '000000' } };  // Text color: Light Steel Blue (ARGB format)
    worksheet.getCell('A3').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
    };
    let headerRow;

    if (currentLevel === "district") {
      headerRow = ['S.No', 'District', 'Total No. of CMR Godowns', 'No. Of CMR Inspections by QC', 'No. of CMR Godowns Inspected ', 'No. of CMR Godowns Pending ', '% of CMR Godowns Inspected by QC'];
    } else if (currentLevel === "subdivision") {
      headerRow = ['S.No', 'Sub-Division', 'Total No. of CMR Godowns', 'No. Of CMR Inspections by QC', 'No. of CMR Godowns Inspected ', 'No. of CMR Godowns Pending ', '% of CMR Godowns Inspected by QC'];
    } else if (currentLevel === "block") {
      headerRow = ['S.No', 'Block', 'Total No. of CMR Godowns', 'No. Of CMR Inspections  by QC', 'No. of CMR Godowns Inspected ', 'No. of CMR Godowns Pending ', '% of CMR Godowns Inspected  by QC'];
    }

    // Add dynamic header row
    worksheet.addRow(headerRow);

    // Apply header style: bold, size 12, and orange background
    worksheet.getRow(4).font = { bold: true, size: 12 };
    worksheet.getRow(4).alignment = { horizontal: 'center' }; // Center alignment

    // Apply background color to the first 6 cells of the header row
    for (let col = 1; col <= 7; col++) {
      const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFA500' }  // Orange background color
      };
      // Apply font styling: bold and size 12
      cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
      // Add border to header cells
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } }
      };
    }

    // Adjust column widths
    worksheet.columns = [
      { key: 'A', width: 10 },  // Column A width
      { key: 'B', width: 20 },  // Column B width
      { key: 'C', width: 25 },  // Column C width
      { key: 'D', width: 25 },  // Column D width
      { key: 'E', width: 30 },  // Column E width
      { key: 'F', width: 30 },  // Column F width
      { key: 'G', width: 30 },  // Column G width
    ];

    // Add data rows
    tableData.forEach((row, index) => {
      const dataRow = worksheet.addRow([
        index + 1,  // S.No (column 1)
        row[1],  // District Name / Subdivision Name / Block Name (column 2)
        row[2],  // Total Shops (column 3)
        row[3],  // Inspections (column 5)
        row[4],  // Inspected Shops (column 4)
        row[5],  // Pending Shops (column 6)
        row[6]   // Percentage (column 7)
      ]);

      // Apply cell alignment
      dataRow.eachCell((cell, colNumber) => {
        if (colNumber === 1) {  // S.No (column 1)
          cell.alignment = { horizontal: 'center' };  // Center align for S.No
        } else if (colNumber === 2) {  // Name (column 2)
          cell.alignment = { horizontal: 'left' };  // Left align for Name
        } else {  // All other columns (3 to 7)
          cell.alignment = { horizontal: 'right' };  // Right align for the other columns
        }
      });
    });

    // Add total row
    worksheet.addRow([
      '',
      'Total',
      formatNumber(totalShops),
      formatNumber(totalInspections),
      formatNumber(inspectedShops),

      formatNumber(pendingShops),
      ((inspectedShops / totalShops) * 100).toFixed(2) + '%'
    ]);

    // Apply total row style: bold, size 12, orange background
    const totalRow = worksheet.lastRow;

    // Apply the styling to the first 6 cells in the total row
    for (let col = 1; col <= 7; col++) {
      const cell = totalRow.getCell(col); // Get each cell in the total row

      // Apply background color (orange) to the total row cells
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF2A6D8B' }  // Orange background color
      };

      // Apply font styling: bold and size 12
      cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };

      // Apply border styling for total row cells
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } }
      };

      // Apply center alignment to all cells except the "Total" text
      if (col === 2) {  // "Total" text in column 2
        cell.alignment = { horizontal: 'left' };  // Left align "Total"
      } else {
        cell.alignment = { horizontal: 'right' };  // Right align the rest of the cells
      }
    }

    const fileName = title.replace(/ /g, '_').replace(/[^a-zA-Z0-9_]/g, '') + '.xlsx';

    // Save the file (Excel)
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    });
  };

  const handleDistrictClick = (districtName, districtId) => {
    // Get the current date and first day of the month for date range
    const formattedFromDate = startDate ? format(startDate, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');
    const formattedToDate = endDate ? format(endDate, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');

    if (!districtId) {
      console.error("District ID is missing or undefined");
      return;
    }

    // Set selected district as the district ID (not the name)
    setSelectedDistrictName(districtName);
    setSelectedDistrict(districtId);  // Store the district ID instead of name
    setSelectedSubDivision(null); // Reset selected subdivision
    setCurrentLevel("subdivision");

    // Make the API request to fetch subdivision data using the district ID
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/reports/subdivision-data/id/${districtId}/surveyType/1/QcType/3/from/${formattedFromDate}/to/${formattedToDate}`)
      //.get(`http://localhost:8080/reports/subdivision-data/id/${districtId}/surveyType/2/from/${formattedFromDate}/to/${formattedToDate}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setSubDivisions(response.data);

          const totals = response.data.reduce(
            (acc, item) => {
              acc.totalGodowns += item.totalGodowns || 0;
              acc.godownsInspected += item.godownsInspected || 0;
              acc.totalInspections += item.totalInspections || 0;
              acc.godownsPending += item.godownsPending || 0;
              return acc;
            },
            { totalGodowns: 0, godownsInspected: 0, godownsPending: 0, totalInspections: 0 }
          );

          setTotalShops(totals.totalGodowns);
          setInspectedShops(totals.godownsInspected);
          setPendingShops(totals.godownsPending);
          setTotalInspections(totals.totalInspections);
        } else {
          console.error("No subdivision data found for this district.");
          setTotalShops(0);
          setInspectedShops(0);
          setPendingShops(0);
          setTotalInspections(0);
        }
      })
      .catch((error) => {
        console.error("Error fetching subdivision data:", error);
        setTotalShops(0);
        setInspectedShops(0);
        setPendingShops(0);
        setTotalInspections(0);
      });
  };


  const handleSubDivisionClick = (subdivisionName, subdivisionId) => {
    // console.log("Selected subdivision:", subdivisionName);
    // console.log("Sub-division ID:", subdivisionId);
    const formattedFromDate = startDate ? format(startDate, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');
    const formattedToDate = endDate ? format(endDate, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');


    if (!subdivisionId) {
      console.error("Sub-division ID is missing or undefined");
      return;
    }

    setSelectedSubDivision(subdivisionName); // Set selected subdivision
    setSelectedBlock(null); // Reset selected block when changing subdivision
    setCurrentLevel("block"); // Move to block level

    // Fetch blocks after setting the selected subdivision
       axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/block-data/id/${subdivisionId}/surveyType/1/QcType/3/from/${formattedFromDate}/to/${formattedToDate}`)
 // axios.get(`http://localhost:8080/reports/block-data/id/${subdivisionId}/surveyType/2/from/${formattedFromDate}/to/${formattedToDate}`)
  .then((response) => {
    if (response.data && response.data.length > 0) {
      setBlocks(response.data);
      // Calculate totals for subdivisions
      const totals = response.data.reduce(
        (acc, item) => {
          acc.totalGodowns += item.totalGodowns;
          acc.godownsInspected += item.godownsInspected;
          acc.totalInspections += item.totalInspections;
          acc.godownsPending += item.godownsPending;
          return acc;
        },
        { totalGodowns: 0, godownsInspected: 0, godownsPending: 0, totalInspections: 0 }
      );

      // Set the calculated totals
      setInspectedShops(totals.godownsInspected);
      setPendingShops(totals.godownsPending);
      setTotalShops(totals.totalGodowns);
      setTotalInspections(totals.totalInspections);
        } else {
          console.error("No block data found for this subdivision.");
        }
      })
      .catch((error) => {
        console.error("Error fetching block data:", error);
      });
  };

  const handleBlockClick = (blockName, blockId) => {
    // console.log("Selected subdivision:", subdivisionName);
    // console.log("Sub-division ID:", subdivisionId);

    if (!blockName) {
      console.error("Sub-division ID is missing or undefined");
      return;
    }

    setSelectedBlock(blockName); // Set selected subdivision
    setSelectedPanchayat(null); // Reset selected block when changing subdivision
    setCurrentLevel("panchayat"); // Move to block level
    setSelectedBlock(blockId);
    // Fetch blocks after setting the selected subdivision
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/block-data/id/${blockId}/date/${selectedDate}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setBlocks(response.data);
          // Calculate totals for subdivisions
          const totals = response.data.reduce(
            (acc, item) => {
              acc.totalShops += item.totalShops;
              acc.inspectedShops += item.inspectedShops;
              acc.totalInspections += item.totalInspections;
              acc.pendingShops += item.pendingShops;
              return acc;
            },
            { totalShops: 0, inspectedShops: 0, pendingShops: 0, totalInspections: 0 }
          );

          // Set the calculated totals
          setInspectedShops(totals.inspectedShops);
          setPendingShops(totals.pendingShops);
          setTotalShops(totals.totalShops);
          setTotalInspections(totals.totalInspections);
        } else {
          console.error("No block data found for this subdivision.");
        }
      })
      .catch((error) => {
        console.error("Error fetching block data:", error);
      });
  };
  // Go back to previous level
  const goBack = () => {
    if (currentLevel === "panchayat") {
      setCurrentLevel("block");
      fetchBlockData();
    } else if (currentLevel === "block") {
      setCurrentLevel("subdivision");
      fetchSubdivisionData();

    } else if (currentLevel === "subdivision") {
      setCurrentLevel("district");

      // Use selected dates for fetching district-wise data
      const formattedFromDate = startDate ? format(startDate, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');
      const formattedToDate = endDate ? format(endDate, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');

      getDistrictWiseData(formattedFromDate, formattedToDate);
    }
  };

  // useEffect hook to fetch subdivision data and calculate totals dynamically

  // Function to fetch SubdivisionData data and calculate totals
  const fetchSubdivisionData = () => {
    const formattedFromDate = startDate ? format(startDate, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');
    const formattedToDate = endDate ? format(endDate, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd');

    if (!selectedDistrict) {
      console.error("District not selected. Cannot fetch subdivision data.");
      return;
    }

    axios
       .get(`${process.env.REACT_APP_API_BASE_URL}/reports/subdivision-data/id/${selectedDistrict}/surveyType/1/QcType/3/from/${formattedFromDate}/to/${formattedToDate}`)
    //  .get(`http://localhost:8080/reports/subdivision-data/id/${selectedDistrict}/surveyType/2/from/${formattedFromDate}/to/${formattedToDate}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setSubDivisions(response.data); // Set subdivisions data

          // Dynamically calculate totals based on the fetched data
          const totals = response.data.reduce(
            (acc, item) => {
              acc.totalGodowns += item.totalGodowns || 0;
              acc.godownsInspected += item.godownsInspected || 0;
              acc.totalInspections += item.totalInspections || 0;
              acc.godownsPending += item.godownsPending || 0;
              return acc;
            },
            { totalGodowns: 0, godownsInspected: 0, godownsPending: 0, totalInspections: 0 }
          );


          // Set the dynamically calculated totals
          setTotalShops(totals.totalGodowns);
          setInspectedShops(totals.godownsInspected);
          setPendingShops(totals.godownsPending);
          setTotalInspections(totals.totalInspections);
        } else {
          console.error("No subdivision data found for this district.");
          // Reset totals if no data is found
          setTotalShops(0);
          setInspectedShops(0);
          setPendingShops(0);
          setTotalInspections(0);
        }
      })
      .catch((error) => {
        console.error("Error fetching subdivision data:", error);
        // Reset state on error
        setTotalShops(0);
        setInspectedShops(0);
        setPendingShops(0);
        setTotalInspections(0);
      });
  };
  const fetchBlockData = () => {
    if (!selectedDistrict) {
      console.error("District not selected. Cannot fetch subdivision data.");
      return;
    }

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/reports/subdivision-data/id/${selectedDistrict}/date/${selectedDate}`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setSubDivisions(response.data); // Set subdivisions data

          // Dynamically calculate totals based on the fetched data
          const totals = response.data.reduce(
            (acc, item) => {
              acc.totalShops += item.totalShops || 0;
              acc.inspectedShops += item.inspectedShops || 0;
              acc.totalInspections += item.totalInspections || 0;
              acc.pendingShops += item.pendingShops || 0;
              return acc;
            },
            { totalShops: 0, inspectedShops: 0, pendingShops: 0, totalInspections: 0 }
          );

          // Set the dynamically calculated totals
          setTotalShops(totals.totalShops);
          setInspectedShops(totals.inspectedShops);
          setPendingShops(totals.pendingShops);
          setTotalInspections(totals.totalInspections);
        } else {
          console.error("No subdivision data found for this district.");
          // Reset totals if no data is found
          setTotalShops(0);
          setInspectedShops(0);
          setPendingShops(0);
          setTotalInspections(0);
        }
      })
      .catch((error) => {
        console.error("Error fetching subdivision data:", error);
        // Reset state on error
        setTotalShops(0);
        setInspectedShops(0);
        setPendingShops(0);
        setTotalInspections(0);
      });
  };

  //console.log("Rendering blocks:", blocks);
  //console.log("Current Level:", currentLevel);
  // console.log("Selected Subdivision:", selectedSubDivision);

  // Get filtered data based on the current level
  const filteredData =
    currentLevel === "district" ? data :
      currentLevel === "subdivision" ? subDivisions : currentLevel === "block" ? blocks : panchayats[selectedBlock] || []
  // blocks[selectedSubDivision] || [];
  // Use staticBlocks as per your existing logic

  const capitalizeFirstLetter = (text) => {
    // Check if the text is defined and not empty
    if (text && typeof text === 'string') {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    return ''; // Return an empty string if text is undefined or not a string
  };

  //console.log("Filtered Data:", filteredData);


  const formatNumber = (number) => {
    return new Intl.NumberFormat('en-IN').format(number); // 'en-IN' for Indian number formatting (commas at appropriate positions)
  };
  const handleClick = (buttonName, path) => {
    setActiveButton(buttonName);
    navigate(path);
  };


  return (
    <div className="QC-CMR-sizes-widths">
      {/* Bar Chart Section */}
      {/* <div className='button-group'>
       <button
        className={`groupOfButtons ${activeButton === 'fps' ? 'active' : ''}`}
        onClick={() => handleClick('fps', '/home')}
        disabled={activeButton === 'fps'}
      >
        FPS
      </button>
      
      <button
        className={`groupOfButtons ${activeButton === 'cms' ? 'active' : ''}`}
        onClick={() => handleClick('cms', '/cmrDashboard')}
        disabled={activeButton === 'cms'}
      >
        CMR
      </button>

      <button
        className={`groupOfButtons ${activeButton === 'QC-CMR' ? 'active' : ''}`}
        onClick={() => handleClick('QC-CMR', '/QC-CMRDashboard')}
        disabled={activeButton === 'QC-CMR'}
      >
        QC-CMR
      </button>
      </div>
      <div className="insideMainContainer_HomePage">  */}
      <div>

        <div className="QC-CMR-conenteofPara"> </div>
        
        <div className="QC-CMR-bar-style">
          <div className="QC-CMR-bar-and-dispaly">
           
            <div className='QC-CMR-name-box-inspection'>
              <div className='QC-CMR-boxes-potion-change'>
                <div className="QC-CMR-inspection-date">
                QC-CMR Inspections of {currentDateTime.date}
                </div>
                <div>
                  <div className="QC-CMR-kpi-cards-container-first-box-number">
                    <div className="QC-CMR-kpi-card-first-box">

                      <Link to="/qcCmrCompletedInspectionToday" target="_blank" style={{ textDecoration: 'none' }}>
                        <div className="QC-CMR-kpi-number-first-box" style={{ color: "#FF6F61" }}>{formatNumber(apiData.completedInspectionsToday)}</div>
                        <div className="QC-CMR-kpi-label-first-box">Completed QC-CMR Inspections</div>
                      </Link>
                    </div>
                    <div className="QC-CMR-kpi-card-first-box">
                      <Link to="/QcCmrOngoingInspectionToday" target="_blank" style={{ textDecoration: 'none' }}>
                        <div className="QC-CMR-kpi-number-first-box" style={{ color: "#B05BC4" }}>{formatNumber(apiData.ongoingInspectionsToday)}</div>
                        <div className="QC-CMR-kpi-label-first-box">Ongoing QC-CMR Inspections</div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="QC-CMR-kpi-cards-container-first-box">
              <div>
                <div className="QC-CMR-UserInspection-container" >
                  <p>QC-CMR Inspection History of {isLoggedIn && (<span> {capitalizeFirstLetter(userInfo.fullName)}</span>)}</p>
                  <div className="QC-CMR-UserInspection-group-cu-1">

                    <label className="QC-CMR-Period-Inspection" htmlFor="Period">
                      Period:
                    </label>
                    <select value={period} onChange={getDateRange}>
                      <option>Current Month</option>
                      <option>Last 3 Months</option>
                      <option>Last 6 Months</option>
                    </select>
                  </div>

                  {loading ? ( // Show loading message while data is being fetched
                    <div className="loading-message">Loading...</div>
                  ) : (
                    <div >
                      <div
                        className={`QC-CMR-UserInspection-stats-grid ${period === "Current Month" ? "two-boxes" : "four-boxes"}`}
                      >
                        {dataUserInspection[period].map((item, index) => (
                          <div
                            key={index}
                            className="QC-CMR-UserInspection-card"
                            style={{ backgroundColor: item.color }}
                          >
                            <h3>{formatNumber(item.count)}</h3>
                            <p>{item.label}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>

      <div className="QC-CMR-multiple-boxes-bars">
        <div className="QC-CMR-kpi-cards-container">

          {/* <div className="QC-CMR-kpi-card">
            <div className="QC-CMR-kpi-number" style={{ color: "#FF6F61" }}>{formatNumber(apiData.targetInspectionsCurrMonth)}</div>
            <div className="QC-CMR-kpi-label">Target QC-CMR Inspections For Current Month</div>
          </div> */}
        
          <div className="QC-CMR-kpi-card">
            <div className="QC-CMR-kpi-number" style={{ color: "#B05BC4" }}>{formatNumber(apiData.inspectionsDoneCurrMonth)}</div>
            <div className="QC-CMR-kpi-label">Total QC-CMR Inspections Done In Current Month</div>
          </div>
         
          <div className="QC-CMR-kpi-card">
            <div className="QC-CMR-kpi-number" style={{ color: "#FFCD00" }}> {formatNumber(apiData.inspectionsDonePast3Months)}</div>
            <div className="QC-CMR-kpi-label">QC-CMR Inspections Done In Last 3 Months</div>
          </div>
        
          <div className="QC-CMR-kpi-card">
            <div className="QC-CMR-kpi-number" style={{ color: "#00A676" }}>{formatNumber(apiData.notInspectedPast3Months)}</div>
            <div className="QC-CMR-kpi-label">QC-CMR Not Inspected In Last 3 Months</div>
          </div>
        </div>
        <div className="QC-CMR-ip-pi-flexclass">
          
          <div className="QC-CMR-chart-container">

            <div className="QC-CMR-input-container">

              <div className='QC-CMR-homeCalMainCal'>
                <div className="QC-CMR-homeCal">
                  <label htmlFor="startDate" className="QC-CMR-items-testing-stock-repo"><span className="asterisk">*</span>From</label>
                  <div className="QC-CMR-homeHCal">
                    <input
                      type="text"
                      id="startDate"
                      className="QC-CMR-HHome-input-repo"
                      value={startDate ? format(startDate, 'dd-MM-yyyy') : ''}
                      readOnly
                      onClick={() => setShowCalendar(true)}
                    />
                    <div className="QC-CMR-HHOME-icon-test-stock-repo" onClick={() => setShowCalendar(true)}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                        <path d="M7 10l5 5 5-5z" />
                      </svg>
                    </div>
                    {showCalendar && (
                      <DatePicker
                        selected={startDate}
                        onChange={handleStartDateChange}
                        onClickOutside={() => setShowCalendar(false)}
                        popperPlacement="bottom-start"
                        minDate={minStartDate} // From January 1st of current year
                        maxDate={currentDate} // Today
                        inline
                      />
                    )}
                  </div>
                </div>

                <div className="QC-CMR-homeCal">
                  <label htmlFor="startDate" className="QC-CMR-items-testing-stock-repo"><span className="asterisk">*</span>To</label>
                  <div className="QC-CMR-homeHCal-1">
                    <input
                      type="text"
                      id="endDate"  // Changed this from 'startDate' to 'endDate'
                      className="QC-CMR-HHome-input-repo"
                      value={endDate ? format(endDate, 'dd-MM-yyyy') : ''}
                      readOnly
                      onClick={() => setShowEndCalendar(true)} // Ensure this toggles correctly
                    />
                    <div className="QC-CMR-HHOME-icon-test-stock-repo" onClick={handleEndDateIconClick}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                        <path d="M7 10l5 5 5-5z" />
                      </svg>
                    </div>
                    {showEndCalendar && (
                      <DatePicker
                        selected={endDate}

                        onChange={handleEndDateChange}
                        onClickOutside={() => setShowEndCalendar(false)}

                        // minDate={minEndDate} // Disable dates before startDate
                        minDate={startDate}
                        maxDate={currentDate} // Today
                        popperPlacement="top-start"
                        inline
                      />
                    )}
                  </div>
                </div>
              </div>







            </div>



          </div>

          {/* Pie Chart */}
          <div className="QC-CMR-pie-chart-container">
            <div className="QC-CMR-pie-chart">
              <Pie data={pieData} options={pieOptions} />
            </div>

            {/* Labels for the pie chart sections */}
            <div className="QC-CMR-chart-labels">
              <div className="QC-CMR-label-item">
                <div className="QC-CMR-color-box-1"></div>
                {/* <span className="span-box-1">No. Of Shops Inspected ({inspectedShops.toLocaleString()})</span> */}
                <span className="QC-CMR-span-box-1">&nbsp;No. of QC-CMR Godown Completed</span>
              </div>

              <div className="QC-CMR-label-item">
                <div className="QC-CMR-color-box-2"></div>
                {/* <span className="span-box-1">No. Of Shops Pending ({pendingShops.toLocaleString()})</span> */}
                <span className="QC-CMR-span-box-1">&nbsp;No. Of QC-CMR Godown Pending</span>
              </div>
            </div>
          </div>
        </div>

     
        <div className="graph-container">
          {/* <div className="QC-CMR-four-garphs">
            <div className="QC-CMR-graph-card-four">
              <Link style={{ textDecoration: 'none' }}>
                {apiData ? (
                  <Bar data={stockQuantityData} options={barOptions} height={400} />
                ) : (
                  <p>Loading...</p> // Show loading text or spinner while apiData is null
                )}
              </Link>
              <h4>Deviation in Stock Quantity (Qtl)</h4>
            </div>

            <div className="QC-CMR-graph-card-four">
              {apiData && apiData.batteryBackUp ? (

                (() => {
                  const batteryBackupData = calculateBatteryBackupPercentages(apiData.batteryBackUp);

                  return (
                    <Link style={{ textDecoration: 'none' }}>
                      <div style={customStyle.progressBarContainer}>
                        {batteryBackupData.map((data, index) => (
                          <div key={index} style={customStyle.progressBar} onClick={() => handleBatteryClick(data)}>
                            <div
                              style={{
                                ...customStyle.progressBarFilled,
                                width: `${data.percentage}%`, // Set the width to the calculated percentage
                                backgroundColor: data.color,
                              }}
                            />
                            <div style={customStyle.label}>{data.label}</div>
                            <div style={customStyle.percentage}>{data.percentage}%</div>
                          </div>
                        ))}
                      </div>
                    </Link>
                  );
                })()
              ) : (
                <p>Loading battery backup data...</p> // Display a loading message if the data is not available yet
              )}
              <h4 style={{ marginTop: "30%" }}>Battery Backup</h4>
            </div>


            <div className="QC-CMR-graph-card-four">

              <Link style={{ textDecoration: 'none' }}>
                <Bar data={equipmentData} options={equipmentDatabarOptions} height={400} />
              </Link>

              <h4>Electricity Connection </h4>
            </div>

            <div className="QC-CMR-graph-card-four">

              <Link style={{ textDecoration: 'none' }}>
                <Bar data={grievanceData} options={grievanceDatabarOptions} height={400} />
              </Link>
              <h4>Weigh Machine Available</h4>
            </div>

          </div> */}

          {/* <div className="QC-CMR-three-garphs">
            <div className="QC-CMR-graph-card-three">

              <div className="QC-CMR-legend-container">
                <div className="QC-CMR-legend-item">
                  <div className="QC-CMR-legend-color" style={{ backgroundColor: '#3ec79b' }}></div>
                  <div className="QC-CMR-legend-label">Yes</div>
                </div>
                <div className="QC-CMR-legend-item">
                  <div className="QC-CMR-legend-color" style={{ backgroundColor: '#FA8072' }}></div>
                  <div className="QC-CMR-legend-label">No</div>
                </div>
              </div>

              <Link style={{ textDecoration: 'none', textColor: 'black' }}>
                <div style={customStyleQuantity.progressBarContainer}>
                  {quantityOfFoodGrain.map((data, index) => (
                    <div key={index} style={customStyleQuantity.progressBar} onClick={() => handleQuantityFoodGrainClick(data)}>
                      <div
                        style={{
                          ...customStyleQuantity.progressBarFilled,
                          width: `${data.percentage}%`,
                          backgroundColor: data.color,
                        }}
                      />
                      <div style={{ ...customStyleQuantity.label, color: 'black' }}>{data.label}</div>

                      <div style={customStyleQuantity.percentage}>{data.percentage}%</div>
                    </div>
                  ))}
                </div>
              </Link>
              <h4 style={{ marginTop: "10%" }}>Electricity Connection</h4>


            </div>

            <div className="QC-CMR-graph-card-three">

              <div className="QC-CMR-legend-container">
                <div className="QC-CMR-legend-item">
                  <div className="QC-CMR-legend-color" style={{ backgroundColor: '#3ec79b' }}></div>
                  <div className="QC-CMR-legend-label">Yes</div>
                </div>
                <div className="QC-CMR-legend-item">
                  <div className="QC-CMR-legend-color" style={{ backgroundColor: '#FA8072' }}></div>
                  <div className="QC-CMR-legend-label">No</div>
                </div>
              </div>

              <Link style={{ textDecoration: 'none' }}>
                <div style={customStyleQunality.progressBarContainer}>
                  {qualityOfFood.map((data, index) => (
                    <div key={index} style={customStyleQunality.progressBar} onClick={() => handleQualityFoodGrainClick(data)}>
                      <div
                        style={{
                          ...customStyleQunality.progressBarFilled,
                          width: `${data.percentage}%`,
                          backgroundColor: data.color,
                        }}
                      />
                      <div style={{ ...customStyleQunality.label, color: 'black' }}>{data.label}</div>
                      <div style={customStyleQunality.percentage}>{data.percentage}%</div>
                    </div>
                  ))}
                </div>
              </Link>
              <h4 style={{ marginTop: "10%" }}>Is WeighMachine Available</h4>


            </div>

            <div className="QC-CMR-graph-card-three">
             
              <div className="QC-CMR-legend-container">
                <div className="QC-CMR-legend-item">
                  <div className="QC-CMR-legend-color" style={{ backgroundColor: '#3ec79b' }}></div>
                  <div className="QC-CMR-legend-label">Yes</div>
                </div>
                <div className="QC-CMR-legend-item">
                  <div className="QC-CMR-legend-color" style={{ backgroundColor: '#FA8072' }}></div>
                  <div className="QC-CMR-legend-label">No</div>
                </div>
              </div>

              <Link style={{ textDecoration: 'none' }}>
                <div style={customStyleLicense.progressBarContainer}>
                  {licensedSiteCompliance.map((data, index) => (
                    <div key={index} style={customStyleLicense.progressBar} onClick={() => handleLicensedSiteClick(data)}>
                      <div
                        style={{
                          ...customStyleLicense.progressBarFilled,
                          width: `${data.percentage}%`,
                          backgroundColor: data.color,
                        }}
                      />
                      <div style={{ ...customStyleLicense.label, color: 'black' }}>{data.label}</div>
                      <div style={customStyleLicense.percentage}>{data.percentage}%</div>
                    </div>
                  ))}
                </div>
              </Link>
              <h4 style={{ marginTop: "10%" }}>Is CCTV Available</h4>


            </div>


          </div> */}
        </div>

      </div>

      <div className="QC-CMR-border-above-name">
        <div className="QC-CMR-conenteofPara-1">QC-CMR Godown Inspection History</div>
        <div className="QC-CMR-border-pi">


          {/* Table Section */}
          <div className="QC-CMR-home-main">
            <div className="QC-CMR-button-container">
              <button className="QC-CMR-dowPdf" onClick={downloadPDF}>
                Download Pdf
              </button>
              <button onClick={downloadExcel} className="QC-CMR-dowPdf">
                Download Xlsx
              </button>
            </div>

            {/* District Table */}
            {currentLevel === "district" && (
              <table className="QC-CMR-table-home">
                <thead className="QC-CMR-head-home">
                  <tr className="tr-home-table">
                    <th>S.No</th>
                    <th>District</th>
                    <th>Total No. of CMR Godowns</th>
                    <th>No.Of CMR Inspections by QC</th>
                    <th>No. of CMR Godowns Inspected </th>
                    <th>No. of CMR Godowns Pending</th>
                    <th>% of CMR Godowns Inspected by QC</th>
                  </tr>
                  <tr className="QC-CMR-total-tr">
                    <td colSpan="2" >
                      <strong>Total</strong></td>
                    <td>{formatNumber(totalShops)}</td>
                    <td>{formatNumber(totalInspections)}</td>
                    <td>{formatNumber(inspectedShops)}</td>

                    <td>{formatNumber(pendingShops)}</td>
                    <td>{totalShops !== 0 ? ((inspectedShops / totalShops) * 100).toFixed(2) + '%' : '0.00%'}</td>
                  </tr>
                </thead>
                <tbody className="QC-CMR-tbody-tr">
                  {filteredData?.map((row, index) => (
                    <tr
                      key={index}
                    //   onClick={() => handleDistrictClick(row.districtName, row.districtId)}
                    >
                      <td>{index + 1}</td>
                      <td>{capitalizeFirstLetter(row.districtName)}</td>
                      <td>{formatNumber(row.totalGodowns)}</td>
                      <td>{formatNumber(row.totalInspections)}</td>
                      <td>{formatNumber(row.godownsInspected)}</td>
                      <td>{formatNumber(row.godownsPending)}</td>

                      <td>{row.percentage}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* SubDivision Table */}
            {/* {currentLevel === "subdivision" && selectedDistrict && (
              <div className="subdivision-table">
                <button onClick={goBack} className="back-button">Back</button>
                <h3>{capitalizeFirstLetter(selectedDistrictName)}</h3>
                <table className="QC-CMR-table-home">
                  <thead className="QC-CMR-head-home">
                    <tr className="tr-home-table">
                      <th>S.No</th>
                      <th>Sub Division</th>
                      <th>Total No. of CMR Godowns</th>
                      <th>No.Of CMR Inspections by QC</th>
                      <th>No. of CMR Godowns Inspected </th>
                      <th>No. of CMR Godowns Pending </th>
                      <th>% of CMR Godowns Inspected by QC</th>
                    </tr>
                    <tr className="QC-CMR-total-tr">
                      <td colSpan="2">
                        <strong>Total</strong>
                      </td>
                      <td>{formatNumber(totalShops)}</td>
                      <td>{formatNumber(totalInspections)}</td>
                      <td>{formatNumber(inspectedShops)}</td>

                      <td>{formatNumber(pendingShops)}</td>
                      <td>{totalShops !== 0 ? ((inspectedShops / totalShops) * 100).toFixed(2) + '%' : '0.00%'}</td>
                    </tr>
                  </thead>
                  <tbody className="QC-CMR-tbody-tr">

                    {subDivisions?.map((subdivision, index) => (
                      <tr key={index}
                        onClick={() => {
                          // console.log("Subdivision clicked:", subdivision.subdivisionName);
                          handleSubDivisionClick(subdivision.subdivisionName, subdivision.subdivisionId);
                        }}>
                        <td>{index + 1}</td>
                        <td>{capitalizeFirstLetter(subdivision.subdivisionName)}</td>
                        <td>{formatNumber(subdivision.totalGodowns)}</td>
                        <td>{formatNumber(subdivision.totalInspections)}</td>
                        <td>{formatNumber(subdivision.godownsInspected)}</td>
                        <td>{formatNumber(subdivision.godownsPending)}</td>
                        <td>{subdivision.percentage}%</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )} */}


            {/* Block Table */}
            {/* {currentLevel === "block" && selectedSubDivision && (
              <div className="block-table">
                <button onClick={goBack} className="back-button">Back</button>
                <h3>{capitalizeFirstLetter(selectedDistrictName)} - {capitalizeFirstLetter(selectedSubDivision)}</h3>
                <table className="QC-CMR-table-home">
                  <thead className="QC-CMR-head-home">
                    <tr className="tr-home-table">
                      <th>S.No</th>
                      <th>Block</th>
                      <th>Total No. of CMR Godowns</th>
                      <th>No. Of CMR Inspections by QC</th>
                      <th>No. of CMR Godowns Inspected </th>
                      <th>No. of CMR Godowns Pending</th>
                      <th>% of CMR Godowns Inspected by QC</th>
                    </tr>
                    <tr className="QC-CMR-total-tr">
                      <td colSpan="2">
                        <strong>Total</strong>
                      </td>
                      <td>{formatNumber(totalShops)}</td>
                      <td>{formatNumber(totalInspections)}</td>
                      <td>{formatNumber(inspectedShops)}</td>

                      <td>{formatNumber(pendingShops)}</td>
                      <td>{totalShops !== 0 ? ((inspectedShops / totalShops) * 100).toFixed(2) + '%' : '0.00%'}</td>
                    </tr>
                  </thead>
                  <tbody className="QC-CMR-tbody-tr">
                    {blocks?.map((block, index) => (
                      <tr key={index}


                      >
                        <td>{index + 1}</td>
                        <td>{capitalizeFirstLetter(block.blockName)}</td>
                        <td>{formatNumber(block.totalGodowns)}</td>
                        <td>{formatNumber(block.totalInspections)}</td>
                        <td>{formatNumber(block.godownsInspected)}</td>
                        <td>{formatNumber(block.godownsPending)}</td>
                        <td>{block.percentage}%</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )} */}
            {/* panchayat table */}
            {/* {currentLevel === "panchayat" && selectedBlock && (
              <div className="block-table">
                <button onClick={goBack} className="back-button">Back</button>
                <h3>{capitalizeFirstLetter(selectedDistrictName)} - {capitalizeFirstLetter(selectedSubDivision)} - {capitalizeFirstLetter(selectedBlock)}</h3>
                <table className="QC-CMR-table-home">
                  <thead className="QC-CMR-head-home">
                    <tr className="tr-home-table">
                      <th>S.No</th>
                      <th>Panchayat</th>
                      <th>Total No. of CMR Godowns</th>
                      <th>No. Of CMR Inspections by QC</th>
                      <th>No. of CMR Godowns Inspected </th>
                      <th>No. of CMR Godowns Pending </th>
                      <th>% of CMR Godowns Inspected by QC</th>
                    </tr>
                    <tr className="QC-CMR-total-tr">
                      <td colSpan="2">
                        <strong>Total</strong>
                      </td>
                      <td>{formatNumber(totalShops)}</td>
                      <td>{formatNumber(totalInspections)}</td>
                      <td>{formatNumber(inspectedShops)}</td>

                      <td>{formatNumber(pendingShops)}</td>
                      <td>{totalShops !== 0 ? ((inspectedShops / totalShops) * 100).toFixed(2) + '%' : '0.00%'}</td>
                    </tr>
                  </thead>
                  <tbody className="QC-CMR-tbody-tr">
                    {blocks?.map((block, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{capitalizeFirstLetter(block.blockName)}</td>
                        <td>{formatNumber(block.totalShops)}</td>
                        <td>{formatNumber(block.totalInspections)}</td>
                        <td>{formatNumber(block.inspectedShops)}</td>
                        <td>{formatNumber(block.pendingShops)}</td>
                        <td>{block.percentage}%</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )} */}
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default QcCmrDashboard;
